export default __webpack_public_path__ + "static/media/okletsplaySplash_res-hevc-safari.dbebac3a.mp4";